import i18n from "@/i18n";
import moment from "moment-timezone";

export const FILTER_FIELDS = [
    'day',
    'vehicle_display_id',
    'operator_id',
    'field',
    'type',
    'reason_description',
    'shift'
];

export function createEmptyFilters() {
    let filters = {};
    FILTER_FIELDS.forEach(field => {
        filters[field] = {selected: [], text: ''};
    });
    return filters;
}

export function getTypeByMode(mode) {
    if (mode === 1) {
        return i18n.t('AppAnalysisSummary.Produzindo');
    }

    if (mode === 2) {
        return i18n.t('AppAnalysisSummary.Ocioso');
    }

    if (mode === 3) {
        return i18n.t('AppAnalysisSummary.Manobrando');
    }

    if (mode === 4) {
        return i18n.t('AppAnalysisSummary.Deslocando');
    }

    if (mode === 5) {
        return i18n.t('AppAnalysisSummary.Desligado');
    }

    if (mode === 8) {
        return i18n.t('AppAnalysisSummary.Manutenção');
    }

    return i18n.t('AppAnalysisSummary.Sem Dados');
}

export function formatDay(eventStart) {
    if (!eventStart) {
        return '';
    }
    return moment(eventStart * 1000).format('DD/MM/YYYY');
}

export function getFieldValue(event, field) {
    if (field === 'day') {
        return formatDay(event.event_start);
    }

    if (field === 'type') {
        return getTypeByMode(event.mode);
    }

    let value = event[field];
    if (value === null || value === undefined) {
        return '';
    }
    return String(value);
}

export function buildOptions(rawEvents) {
    let options = {};
    FILTER_FIELDS.forEach(field => {
        options[field] = new Set();
    });

    rawEvents.forEach(vehicleEvents => {
        vehicleEvents.forEach(event => {
            FILTER_FIELDS.forEach(field => {
                let value = getFieldValue(event, field);
                if (value !== '') {
                    options[field].add(value);
                }
            });
        });
    });

    let result = {};
    FILTER_FIELDS.forEach(field => {
        let values = Array.from(options[field]);
        result[field] = field === 'day' ? values : values.sort((a, b) => a.localeCompare(b, undefined, {numeric: true}));
    });
    return result;
}

export function countActiveFilters(filters) {
    let count = 0;
    FILTER_FIELDS.forEach(field => {
        let filter = filters[field];
        if (filter.selected.length > 0) {
            count++;
        }
        if (filter.text.trim() !== '') {
            count++;
        }
    });
    return count;
}

function matchesFilters(event, activeFilters) {
    for (let i = 0; i < activeFilters.length; i++) {
        let {field, selected, text} = activeFilters[i];
        let value = getFieldValue(event, field);

        if (selected.length > 0 && !selected.includes(value)) {
            return false;
        }

        if (text !== '' && !value.toLowerCase().includes(text)) {
            return false;
        }
    }
    return true;
}

export function applyFilters(rawEvents, filters) {
    if (countActiveFilters(filters) === 0) {
        return rawEvents.map(vehicleEvents => vehicleEvents.slice());
    }

    let activeFilters = FILTER_FIELDS
        .map(field => ({
            field: field,
            selected: filters[field].selected,
            text: filters[field].text.trim().toLowerCase()
        }))
        .filter(filter => filter.selected.length > 0 || filter.text !== '');

    return rawEvents.map(vehicleEvents => vehicleEvents.filter(event => matchesFilters(event, activeFilters)));
}
